import { render, staticRenderFns } from "./CampaignStepPromo.vue?vue&type=template&id=5a52b680&scoped=true"
import script from "./CampaignStepPromo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignStepPromo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignStepPromo.vue?vue&type=style&index=0&id=5a52b680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52b680",
  null
  
)

export default component.exports